module.exports = __webpack_public_path__ + "img/allafrica.57e80cf9.jpeg";